export const RequireStar = () => <span className="required">*</span>;

export default RequireStar;